// extracted by mini-css-extract-plugin
export default {"Outer":"DraggableContainer_Outer__aEs0b"};